import React from "react";
import { Redirect, Route } from "react-router-dom";
import protectedComponent from "./protected-component";

function ProtectedRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        const linkId = sessionStorage.getItem("linkId");
        if (!linkId) return null;
        return protectedComponent(
          // Using key to remount the same component for profile.
          <Component key={props.location.key} {...props} />,
          <Redirect to={"/app/login/" + linkId} />
        );
      }}
    />
  );
}
export default ProtectedRoute;
